import findChecksDialogTemplate from './findChecksDialog.template.html';

/*******************************************************************************
 * Directive */
/**
 * @ngdoc   directive
 * @module  csm.books.nsf
 * @name    csm.books.nsf.directive:findChecksDialog
 * @description
 * Searches for deposited checks by either check number, or the name on the check.
 *******************************************************************************/
/* @ngInject */ export function findChecksDialogDirective(ClickDialogDirective) {
  return new ClickDialogDirective({
    backdrop: 'static',
    controller: Controller,
    template: findChecksDialogTemplate,
    size: 'lg',
    scope: { filters: '<', load: '&' }
  });
}

/*******************************************************************************
 * Controller */
/**
 * @ngdoc   controller
 * @module  csm.books.nsf
 * @name    csm.books.nsf.controller:Controller
 * @description
 * Sets up the grid options and runs a search.
 *******************************************************************************/
/* @ngInject */ function Controller($injector, $scope, $uibModalInstance, uiGridConstants) {
  /** Self reference. */ var $ctrl = this;

  /*---------------------------------*/
  /* Template to add double click    */
  /* functionality to each grid row. */
  /*---------------------------------*/
  var dblClickTemplate =
    '\
  <div ui-grid-cell\
        ng-dblclick="grid.appScope.$ctrl.selectCheck(row.entity)"\
          ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"\
              class="ui-grid-cell">\
  </div>';

  /*-----------------------------*/
  /* Set up injection functions. */
  /*-----------------------------*/
  $ctrl.search = $injector.invoke(search, null, { $ctrl: $ctrl });
  $ctrl.selectCheck = $injector.invoke(selectCheck, null, {
    $ctrl: $ctrl,
    $scope: $scope
  });
  $ctrl.grid = {
    enableColumnMenus: false,
    enableFiltering: false,
    enableFullRowSelection: true,
    enableSelectAll: false,
    enableSelectionBatchEvent: false,
    multiSelect: false,
    rowTemplate: dblClickTemplate,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableRowSelection: true,
    enableRowHeaderSelection: false,
    onRegisterApi: function (api) {
      $ctrl.grid.api = api;
    },
    data: [],
    columnDefs: [
      { field: 'bankAcct', displayName: 'Bank Account', minWidth: 150 },
      {
        field: 'depositDate',
        displayName: 'Deposited',
        width: 90,
        cellFilter: 'date:"MM/dd/yyyy"',
        type: 'number'
      },
      { field: 'receiptNumber', displayName: 'Receipt #', width: 90 },
      { field: 'receiptFrom', displayName: 'From', width: 150 },
      { field: 'checkNumber', displayName: 'Check #', width: 80 },
      { field: 'checkName', displayName: 'Name', width: 150 },
      {
        field: 'checkAmount',
        displayName: 'Amount',
        width: 90,
        cellFilter: 'currency',
        cellClass: 'text-right'
      }
    ]
  };

  $ctrl.search();
}

/*******************************************************************************
 * clear */
/**
 * Clears the filter object's properties. This is to maintain the filter object
 * reference.
 *******************************************************************************/
/* @ngInject */ function clear($ctrl) {
  return function () {
    $ctrl.filter.checkNumber = null;
    $ctrl.filter.checkName = null;
  };
}

/*******************************************************************************
 * search */
/**
 * Searches for checks based on the filters.
 *******************************************************************************/
/* @ngInject */ function search($ctrl, BusyScreen, NSFChecksService) {
  return function () {
    BusyScreen.promise(
      NSFChecksService.findChecks($ctrl.filters).then(function (checks) {
        $ctrl.grid.data = checks;
      })
    );
  };
}

/*******************************************************************************
 * selectCheck */
/**
 * Select a check to mark as NSF.
 *
 * @param  row  Selected row.
 *******************************************************************************/
/* @ngInject */ function selectCheck($ctrl, $scope, Alert) {
  return function (row) {
    var checks = row ? [row] : $ctrl.grid.api.selection.getSelectedRows();

    /*------------------------------------*/
    /* Must have a single check selected. */
    /*------------------------------------*/
    if (!checks.length) {
      Alert.error('Select a check to mark as NSF first', 'No Selection');
      return;
    }

    $ctrl.load({ $check: checks[0] });
    $scope.$dismiss();
  };
}
